import clsx from 'clsx';
import {
    memo,
    PropsWithChildren,
    useContext,
    useEffect,
} from 'react';
import ReactModal from 'react-modal';
import { RuntimeContext } from 'src/runtimeContext';

type Props = PropsWithChildren<{
    className?: string;
    opened: boolean;
    size?: 'sm' | 'md' | 'lg';
    danger?: boolean;
    fullScreen?: boolean;
    fullHeight?: boolean;
    shaded?: boolean;
    handleClose: () => void;
}>

export const Modal = memo((
    {
        opened,
        danger = false,
        fullScreen = false,
        fullHeight = false,
        shaded = false,
        size = 'md',
        handleClose,
        children,
        className,
    }: Props,
) => {
    const { modalRoot } = useContext(RuntimeContext);

    useEffect(() => {
        document.body.classList.toggle('vss-overflow-hidden', opened);

        return () => {
            document.body.classList.remove('vss-overflow-hidden');
        };
    }, [opened]);

    return (
        <ReactModal
            className={clsx(
                {
                    'vss-modal-overlay': true,
                    'vss-modal-overlay--visible': opened,
                },
                className,
            )}
            isOpen={opened}
            onRequestClose={handleClose}
            parentSelector={() => modalRoot}
            style={{ overlay: {
                zIndex: 7,
            } }}
        >
            <div
                className={clsx({
                    'vss-modal': true,
                    [`vss-modal--${size}`]: true,
                    'vss-modal--visible': opened,
                    'vss-modal--danger': danger,
                    'vss-modal--fullScreen': fullScreen,
                    'vss-modal--shaded': shaded,
                    'vss-modal--full-height': fullHeight,
                })}
            >{children}
            </div>
        </ReactModal>
    );
});
